import { render, staticRenderFns } from "./CreateTabModal.vue?vue&type=template&id=46e51844"
import script from "./CreateTabModal.vue?vue&type=script&lang=js"
export * from "./CreateTabModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTabModal.vue?vue&type=style&index=0&id=46e51844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports